var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "p-3" }, [
    _c("h3", [_vm._v("Scan Berkas RM Details")]),
    _vm._v(" "),
    _c("hr"),
    _vm._v(" "),
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-sm-3" }, [
        _c("h4", { staticClass: "mb-3" }, [_vm._v("Data Pasien")]),
        _vm._v(" "),
        _c("table", { staticClass: "table table-striped" }, [
          _c(
            "tbody",
            _vm._l(_vm.detail_pasien, function (pasien, idx) {
              return _c("tr", { key: idx }, [
                _c("td", [_vm._v(_vm._s(idx))]),
                _vm._v(" "),
                _c("td", [_vm._v(_vm._s(pasien))]),
              ])
            }),
            0
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-sm-9" }, [
        _c("h4", { staticClass: "mb-3" }, [_vm._v("Berkas")]),
        _vm._v(" "),
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-md-6" }, [
            _c("div", { staticClass: "input-group" }, [
              _c("span", { staticClass: "input-group-text" }, [
                _vm._v("IP WebSocket Scanner"),
              ]),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.ip_scanner,
                    expression: "ip_scanner",
                  },
                ],
                staticClass: "form-control",
                attrs: { type: "text", "aria-label": "IP WebSocket" },
                domProps: { value: _vm.ip_scanner },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.ip_scanner = $event.target.value
                  },
                },
              }),
              _vm._v(" "),
              _c("span", { staticClass: "input-group-text" }, [_vm._v("Port")]),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.port,
                    expression: "port",
                  },
                ],
                staticClass: "form-control",
                attrs: { type: "text", "aria-label": "Port", disabled: "" },
                domProps: { value: _vm.port },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.port = $event.target.value
                  },
                },
              }),
              _vm._v(" "),
              _c(
                "button",
                { staticClass: "btn btn-success", on: { click: _vm.scanDocs } },
                [_vm._v("Scan")]
              ),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-md-6" }, [
            _c("div", { staticClass: "input-group" }, [
              _c("span", { staticClass: "input-group-text" }, [
                _vm._v("Berkas"),
              ]),
              _vm._v(" "),
              _c(
                "select",
                {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.file_berkas,
                      expression: "file_berkas",
                    },
                  ],
                  staticClass: "form-select",
                  attrs: { name: "berkas", id: "berkas" },
                  on: {
                    change: function ($event) {
                      var $$selectedVal = Array.prototype.filter
                        .call($event.target.options, function (o) {
                          return o.selected
                        })
                        .map(function (o) {
                          var val = "_value" in o ? o._value : o.value
                          return val
                        })
                      _vm.file_berkas = $event.target.multiple
                        ? $$selectedVal
                        : $$selectedVal[0]
                    },
                  },
                },
                [
                  _c("option", { attrs: { value: "0" } }, [
                    _vm._v("--- Pilih Berkas ---"),
                  ]),
                  _vm._v(" "),
                  _vm.berkas_pasien.length > 0
                    ? _vm._l(_vm.berkas_pasien, function (bp, idx) {
                        return _c(
                          "option",
                          { key: idx, domProps: { value: bp.id } },
                          [_vm._v(_vm._s(bp.doc_title))]
                        )
                      })
                    : _vm._e(),
                ],
                2
              ),
              _vm._v(" "),
              _c("input", {
                ref: "file_upload",
                staticClass: "form-control",
                attrs: {
                  type: "file",
                  "aria-label": "Upload File",
                  accept: "image/*,application/pdf",
                },
              }),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "btn btn-primary",
                  on: { click: _vm.handleFileUpload },
                },
                [_vm._v("Upload File")]
              ),
            ]),
          ]),
        ]),
        _vm._v(" "),
        _vm._m(0),
      ]),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { ref: "modal_scan", staticClass: "modal", attrs: { tabindex: "-1" } },
      [
        _c("div", { staticClass: "modal-dialog" }, [
          _c("div", { staticClass: "modal-content" }, [
            _vm._m(1),
            _vm._v(" "),
            _c("div", { staticClass: "modal-body" }, [
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col" }, [
                  _c(
                    "div",
                    { staticClass: "card", staticStyle: { width: "100%" } },
                    [
                      _c(
                        "div",
                        { staticClass: "card-body" },
                        [
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-sm btn-primary",
                              on: { click: _vm.startScan },
                            },
                            [_vm._v("Scan")]
                          ),
                          _vm._v(" "),
                          _vm.proses_scan
                            ? _c(
                                "div",
                                {
                                  staticClass: "alert alert-info mt-3",
                                  attrs: { role: "alert" },
                                },
                                [
                                  _vm._v(
                                    "\n                                        Proses Scan Dokumen...\n                                    "
                                  ),
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.thumbnail.length > 0
                            ? _c("p", { staticClass: "mt-3" }, [
                                _vm._v(
                                  "Klik pada gambar untuk melihat preview"
                                ),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.thumbnail.length > 0
                            ? _vm._l(_vm.thumbnail, function (thumb, idx) {
                                return _c("img", {
                                  key: idx,
                                  staticStyle: { width: "100%" },
                                  attrs: { src: thumb, alt: "preview-image" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.previewImage(thumb)
                                    },
                                  },
                                })
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _c("div", { staticClass: "row mt-3" }, [
                            _c(
                              "label",
                              {
                                staticClass: "col-sm-4",
                                attrs: { for: "title" },
                              },
                              [_vm._v("Judul")]
                            ),
                            _vm._v(" "),
                            _c("div", { staticClass: "col-sm-8" }, [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.data_berkas.doc_title,
                                    expression: "data_berkas.doc_title",
                                  },
                                ],
                                staticClass: "form-control",
                                attrs: { type: "text", id: "title" },
                                domProps: { value: _vm.data_berkas.doc_title },
                                on: {
                                  input: function ($event) {
                                    if ($event.target.composing) return
                                    _vm.$set(
                                      _vm.data_berkas,
                                      "doc_title",
                                      $event.target.value
                                    )
                                  },
                                },
                              }),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "row mt-3" }, [
                            _c(
                              "label",
                              {
                                staticClass: "col-sm-4",
                                attrs: { for: "desc" },
                              },
                              [_vm._v("Keterangan")]
                            ),
                            _vm._v(" "),
                            _c("div", { staticClass: "col-sm-8" }, [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.data_berkas.doc_description,
                                    expression: "data_berkas.doc_description",
                                  },
                                ],
                                staticClass: "form-control",
                                attrs: { type: "text", id: "desc" },
                                domProps: {
                                  value: _vm.data_berkas.doc_description,
                                },
                                on: {
                                  input: function ($event) {
                                    if ($event.target.composing) return
                                    _vm.$set(
                                      _vm.data_berkas,
                                      "doc_description",
                                      $event.target.value
                                    )
                                  },
                                },
                              }),
                            ]),
                          ]),
                        ],
                        2
                      ),
                    ]
                  ),
                ]),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "modal-footer" }, [
              _c(
                "button",
                {
                  staticClass: "btn btn-secondary",
                  attrs: { type: "button", "data-bs-dismiss": "modal" },
                },
                [_vm._v("Close")]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "btn btn-primary",
                  attrs: { type: "button" },
                  on: { click: _vm.saveThumbnail },
                },
                [_vm._v("Save changes")]
              ),
            ]),
          ]),
        ]),
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      { ref: "modal_preview", staticClass: "modal", attrs: { tabindex: "-1" } },
      [
        _c(
          "div",
          { staticClass: "modal-dialog modal-dialog-scrollable modal-xl" },
          [
            _c("div", { staticClass: "modal-content" }, [
              _vm._m(2),
              _vm._v(" "),
              _c("div", { staticClass: "modal-body" }, [
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col" }, [
                    _vm.preview_scan
                      ? _c("img", {
                          staticStyle: { width: "100%" },
                          attrs: { src: _vm.preview_scan, alt: "" },
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.pdf_preview && _vm.pdf_pages
                      ? _c(
                          "div",
                          _vm._l(_vm.pdf_pages, function (page, idx) {
                            return _c("div", { key: idx }, [
                              _c("canvas", {
                                ref: `pdf_canvas` + idx,
                                refInFor: true,
                              }),
                            ])
                          }),
                          0
                        )
                      : _vm._e(),
                  ]),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "modal-footer" }, [
                _vm.file_upload
                  ? _c(
                      "button",
                      {
                        staticClass: "btn btn-success",
                        attrs: { type: "button" },
                        on: { click: _vm.doUploadFile },
                      },
                      [_vm._v("Upload")]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "btn btn-secondary",
                    attrs: { type: "button", "data-bs-dismiss": "modal" },
                  },
                  [_vm._v("Close")]
                ),
              ]),
            ]),
          ]
        ),
      ]
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "row mt-3" }, [
      _c("div", { staticClass: "col", attrs: { id: "table-berkas-pasien" } }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "modal-header" }, [
      _c("h5", { staticClass: "modal-title" }, [_vm._v("Scan Dokument")]),
      _vm._v(" "),
      _c("button", {
        staticClass: "btn-close",
        attrs: {
          type: "button",
          "data-bs-dismiss": "modal",
          "aria-label": "Close",
        },
      }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "modal-header" }, [
      _c("h5", { staticClass: "modal-title" }, [_vm._v("Preview")]),
      _vm._v(" "),
      _c("button", {
        staticClass: "btn-close",
        attrs: {
          type: "button",
          "data-bs-dismiss": "modal",
          "aria-label": "Close",
        },
      }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }